import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../config/constants';
import { API_BASE_URL } from '../scripts/control';
import '../../css/BdIndex.css';
import '../../css/BdStyles.css';

const BdIndex = () => {
    const [sliders, setSliders] = useState([]);
    const [latestEntries, setLatestEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const carouselRef = useRef(null);

    useEffect(() => {
        // Obtener las últimas 3 películas/series
        const fetchLatestEntries = async () => {
            try {
                // Obtener tanto películas como series
                const [moviesResponse, seriesResponse] = await Promise.all([
                    fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                        },
                        credentials: 'omit',
                    }).catch((error) => {
                        // Error silencioso pero registrado
                        return null;
                    }),
                    fetch(`${API_BASE_URL}/api/BdSeries_func.php`, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                        },
                        credentials: 'omit',
                    }).catch((error) => {
                        // Error silencioso pero registrado
                        return null;
                    })
                ]);

                let allEntries = [];

                // Procesar películas
                if (moviesResponse && moviesResponse.ok) {
                    try {
                        const moviesData = await moviesResponse.json();
                        const movies = moviesData.movies || (Array.isArray(moviesData) ? moviesData : []);
                        const processedMovies = movies
                            .filter(movie => movie.img_url && movie.img_url.trim() !== '')
                            .map(movie => ({
                                ...movie,
                                type: 'movie',
                                id: movie.idMovie || movie.id,
                                name: movie.movieName || movie.name,
                                fullImgUrl: movie.img_url.startsWith('http') 
                                    ? movie.img_url 
                                    : `${API_BASE_URL}/public/uploads/images/${movie.img_url}`
                            }));
                        allEntries = allEntries.concat(processedMovies);
                    } catch (parseError) {
                        // Error al parsear respuesta de películas
                    }
                } else if (moviesResponse && !moviesResponse.ok) {
                    // La petición falló pero no hubo excepción
                }

                // Procesar series
                if (seriesResponse && seriesResponse.ok) {
                    try {
                        const seriesData = await seriesResponse.json();
                        const series = seriesData.series || (Array.isArray(seriesData) ? seriesData : []);
                        const processedSeries = series
                            .filter(serie => serie.img_url && serie.img_url.trim() !== '')
                            .map(serie => ({
                                ...serie,
                                type: 'series',
                                id: serie.idSeries || serie.id,
                                name: serie.seriesName || serie.name,
                                fullImgUrl: serie.img_url.startsWith('http') 
                                    ? serie.img_url 
                                    : `${API_BASE_URL}/public/uploads/images/${serie.img_url}`
                            }));
                        allEntries = allEntries.concat(processedSeries);
                    } catch (parseError) {
                        // Error al parsear respuesta de series
                    }
                } else if (seriesResponse && !seriesResponse.ok) {
                    // La petición falló pero no hubo excepción
                }

                // Ordenar por ID (más reciente = mayor ID) y tomar las 3 primeras
                const latestEntries = allEntries
                    .sort((a, b) => {
                        const idA = parseInt(a.id || 0);
                        const idB = parseInt(b.id || 0);
                        return idB - idA; // Orden descendente
                    })
                    .slice(0, 3);

                setLatestEntries(latestEntries);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                // Error general en fetchLatestEntries
            }
        };

        fetchLatestEntries();

        // Mantener el fetch original para sliders si se necesita
        fetch(`${API_BASE_URL}/api/bdhome_func.php`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
            credentials: 'omit',
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                return { error: `HTTP ${response.status}` };
            })
            .then(data => {
                if (!data.error && Array.isArray(data)) {
                    setSliders(data);
                }
            })
            .catch(() => {
                // Error silencioso
            });
    }, []);

    // Inicializar el carrusel de Bootstrap cuando se monta el componente
    useEffect(() => {
        if (latestEntries.length > 0) {
            // Esperar a que el DOM esté listo
            const initCarousel = () => {
                const carouselElement = document.getElementById('latestEntriesCarousel');
                if (carouselElement) {
                    // Verificar si Bootstrap está disponible
                    if (window.bootstrap && window.bootstrap.Carousel) {
                        try {
                            // Inicializar el carrusel con Bootstrap
                            const carousel = new window.bootstrap.Carousel(carouselElement, {
                                interval: 3000, // 3 segundos
                                ride: 'carousel',
                                wrap: true
                            });
                            carouselRef.current = carousel;
                        } catch (error) {
                            // Si falla, el carrusel funcionará con los atributos data-bs-*
                        }
                    }
                }
            };

            // Intentar inmediatamente
            initCarousel();
            
            // También intentar después de un pequeño delay por si Bootstrap se carga después
            const timeoutId = setTimeout(initCarousel, 100);
            
            return () => clearTimeout(timeoutId);
        }
    }, [latestEntries]);

    return (
        <div className="bd">
        <div className="container">
            {/* Logo */}
            <div className="row">
                <div className="logo-container">
                    <div className="logo-content d-flex justify-content-center flex-wrap">
                        <span className="logo-letter" id="bdlogo-B">B</span>
                        <span className="logo-letter" id="bdlogo-D">D</span>
                        <span className="logo-letter" id="bdlogo-E">E</span>
                        <span className="logo-letter" id="bdlogo-P">P</span>
                        <span className="logo-letter" id="bdlogo-I">I</span>
                        <span className="logo-letter" id="bdlogo-C">C</span>
                        <span className="logo-letter" id="bdlogo-A">A</span>
                        <span className="bdlogo-balloon">
                            <img src={`${API_BASE_URL}/public/uploads/images/comic.png`}/>
                        </span>
                    </div>
                </div>
                <div className="logotext text-center">
                    <p className="logo-text">Base de Datos y Etiquetas <br /> Para la Investigación de Contenidos Audiovisuales</p>
                </div>

                {/* Carrusel de últimas entradas */}
                {!loading && latestEntries.length > 0 && (
                    <div className="latest-entries-carousel-container mt-5 mb-4">
                        <h3 className="text-center mb-4" style={{ color: '#005EC4', fontWeight: 'bold' }}>
                            Últimas Entradas
                        </h3>
                        <div id="latestEntriesCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
                            <div className="carousel-indicators">
                                {latestEntries.map((_, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        data-bs-target="#latestEntriesCarousel"
                                        data-bs-slide-to={index}
                                        className={index === 0 ? 'active' : ''}
                                        aria-current={index === 0 ? 'true' : 'false'}
                                        aria-label={`Slide ${index + 1}`}
                                    ></button>
                                ))}
                            </div>
                            <div className="carousel-inner">
                                {latestEntries.map((entry, index) => {
                                    // Determinar la ruta correcta según el tipo
                                    const detailRoute = entry.type === 'series' 
                                        ? ROUTE_PATHS.DETAIL_LINK.SERIES(entry.id)
                                        : ROUTE_PATHS.DETAIL_LINK.MOVIE(entry.id);
                                    
                                    return (
                                        <div
                                            key={entry.id}
                                            className={`carousel-item ${index === 0 ? 'active' : ''}`}
                                        >
                                            <Link
                                                to={detailRoute}
                                                style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                                                onClick={(e) => {
                                                    // Prevenir que el carousel interfiera con la navegación
                                                    e.stopPropagation();
                                                }}
                                            >
                                                <div className="carousel-image-wrapper">
                                                    <img
                                                        src={entry.fullImgUrl || entry.img_url || `${API_BASE_URL}/public/uploads/images/${entry.img_url}`}
                                                        alt={entry.name || 'Entrada'}
                                                        className="d-block w-100 carousel-image"
                                                        loading={index === 0 ? 'eager' : 'lazy'}
                                                        onError={(e) => {
                                                            // Si la imagen falla, mostrar un placeholder
                                                            e.target.src = 'https://via.placeholder.com/800x500/005EC4/FFFFFF?text=Sin+Imagen';
                                                        }}
                                                    />
                                                    <div className="carousel-caption d-none d-md-block">
                                                        <h5>{entry.name}</h5>
                                                        {(entry.movieYear || entry.seriesYear) && <p>{entry.movieYear || entry.seriesYear}</p>}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    );
                                })}
                            </div>
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#latestEntriesCarousel"
                                data-bs-slide="prev"
                            >
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#latestEntriesCarousel"
                                data-bs-slide="next"
                            >
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* Mensaje si no hay entradas después de cargar */}
                {!loading && latestEntries.length === 0 && (
                    <div className="text-center mt-5 mb-4">
                        <p style={{ color: '#666', fontSize: '0.9rem' }}>
                            No hay entradas disponibles para mostrar en el carrusel.
                        </p>
                    </div>
                )}

                <div className="d-flex justify-content-center mt-5 social-index">
                    <a href="https://www.instagram.com/ligaincom" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram instagram me-5"></i></a>
                    <a href="https://x.com/ligaincom" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-x-twitter twitter ms-5"></i></a>
                </div>
            </div>


            {/* Slider */}
            {/*<div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {sliders.map((item, index) => (
                        <div key={item.id} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                            <img className="d-block w-100" src={item.img_url || 'https://via.placeholder.com/800x400'} alt={`${item.name} slide`} />
                            <div className="carousel-caption d-none d-md-block">
                                <h5>{item.name}</h5>
                                <p>{item.type === 'movies' ? 'Película' : 'Serie'}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img className="d-block w-100" src="..." alt="First slide" />
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="..." alt="Second slide" />
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="..." alt="Third slide" />
    </div>
  </div>
</div>*/}
       </div>
       <br />
       <div className="financing-banner">
    <p>
    <a href="https://www.investigacion.us.es/divulgacion/divulga-us" target="_blank" rel="noopener noreferrer">
        <img src={`https://grupo.us.es/ligaincom/public/uploads/images/logous.png`} width="180px" height="auto" alt="Logous" id="logo-us" />
    </a>
        Proyecto financiado por <a href="https://www.investigacion.us.es/divulgacion/divulga-us" target="_blank" rel="noopener noreferrer">
        Ayudas para Actividades de Divulgación Científica del Plan Propio de la Universidad de Sevilla
        </a>
    </p>
</div>
       </div>
    );
};

export default BdIndex;
